import React, { Component } from 'react';
import { connect } from 'dva';
import { Button, Row, Col, Form, Input, Tooltip, Cascader, message, Badge } from 'antd';
import { getAppCode } from '../../../../utils/utils';
import ListPage from '../../../../../../../components/ListPage';
import { convertData, getLabelStrData } from '../../../../utils/convertData';
import styles from './index.less';

const { ListTable } = ListPage;
@connect(({ microToPublic }) => ({
  ...microToPublic,
}))
class ArticleTable extends Component {
  constructor(props) {
    super(props);
    this.state = {
      columns: [],
      channelList: [],
      // selectedRowKeys: []
    };
  }

  componentDidMount() {
    const { params } = this.props;

    this.setColumns();
    this.fetchChannelList();
    this.fetchPublishList({ ...params, appCode: getAppCode() });
  }

  search = e => {
    e.preventDefault();
    const { form, dispatch, params } = this.props;
    form.validateFieldsAndScroll((err, values) => {
      if (!err) {
        const tempParams = {
          ...params,
          title: values.title ? encodeURIComponent(values.title) : '',
          channelId: values.channelId[0] === 0 ? '' : values.channelId[values.channelId.length - 1],
          page: 1,
        };
        dispatch({
          type: 'microToPublic/saveState',
          payload: {
            params: tempParams,
          },
        });
        this.fetchPublishList(tempParams);
      }
    });
  };

  reSet = () => {
    const { form, dispatch, params } = this.props;
    form.resetFields();
    const tempParams = {
      ...params,
      title: '',
      channelId: '',
      page: 1,
    };
    dispatch({
      type: 'microToPublic/saveState',
      payload: {
        params: tempParams,
      },
    });
    this.fetchPublishList(tempParams);
  };

  fetchPublishList = params => {
    const { dispatch, type } = this.props;
    let paramsTemp = { ...params };
    if (type === 'microToPublic') {
      paramsTemp = { ...params, filtratiolink: 1 };
    }

    this.setLoading(true);
    dispatch({
      type: 'microToPublic/fetchPublishList',
      params: paramsTemp,
    })
      .then(res => {
        dispatch({
          type: 'microToPublic/saveState',
          payload: {
            dataSource: getLabelStrData(res),
            totalElements: res.totalElements,
          },
        });
        this.setLoading(false);
      })
      .catch(() => {
        this.setLoading(false);
      });
  };

  fetchChannelList = () => {
    const { dispatch } = this.props;
    this.setLoading(true);
    dispatch({
      type: 'artcleLists/fetchChannelList',
      params: { appCode: getAppCode() },
    })
      .then(res => {
        const data = convertData(res || []);
        data.unshift({ value: 0, label: '全部', children: [] });
        this.setState({
          channelList: data,
        });
        this.setLoading(false);
      })
      .catch(() => {
        this.setLoading(false);
      });
  };

  setLoading = flag => {
    const { dispatch } = this.props;
    dispatch({
      type: 'microToPublic/saveState',
      payload: {
        spinning: flag,
      },
    });
  };

  setColumns = () => {
    const { type } = this.props;
    let columns = [];
    if (type === 'batchPush') {
      columns = [
        {
          title: '文章标题',
          dataIndex: 'title',
          key: 'title',
          width: 330,
          render: (text, record) => {
            if (text.length <= 20) {
              return (
                <>
                  {record.newsInfoExtend && record.newsInfoExtend.upDownType === '2' && (
                    <span className="Bureau">
                      <p>局</p>
                    </span>
                  )}
                  <span>{text}</span>
                </>
              );
            }
            return (
              <Tooltip placement="top" title={text}>
                {record.newsInfoExtend && record.newsInfoExtend.upDownType === '2' && (
                  <span className="Bureau">
                    <p>局</p>
                  </span>
                )}
                <span>{text.substring(0, 20)}...</span>
              </Tooltip>
            );
          },
        },
        {
          title: '所在栏目',
          dataIndex: 'channel',
          key: 'channel',
          render: text => {
            return <span>{text && text.title}</span>;
          },
        },
        {
          title: '是否已经推送',
          dataIndex: 'pushed',
          key: 'pushed',
          render: pushed => {
            return <Badge color={pushed ? '#52C41A' : '#C3C3C3'} text={pushed ? '是' : '否'} />;
          },
        },
      ];
    } else {
      columns = [
        {
          title: '文章标题',
          dataIndex: 'title',
          key: 'title',
          width: 330,
          render: (text, record) => {
            if (text.length <= 20) {
              return (
                <>
                  {record.newsInfoExtend && record.newsInfoExtend.upDownType === '2' && (
                    <span className="Bureau">
                      <p>局</p>
                    </span>
                  )}
                  <span>{text}</span>
                </>
              );
            }
            return (
              <Tooltip placement="top" title={text}>
                {record.newsInfoExtend && record.newsInfoExtend.upDownType === '2' && (
                  <span className="Bureau">
                    <p>局</p>
                  </span>
                )}
                <span>{text.substring(0, 20)}...</span>
              </Tooltip>
            );
          },
        },
        {
          title: '所在栏目',
          dataIndex: 'channel',
          key: 'channel',
          width: 220,
          render: text => {
            return <span>{text && text.title}</span>;
          },
        },
        {
          title: '关联标签',
          dataIndex: 'labelList',
          key: 'labelList',
          render: (text, record) => {
            const str = record.labelData && record.labelData.join(';');
            if (!str) {
              return <span>-</span>;
            }
            if (str.length <= 12) {
              return <span>{str}</span>;
            }
            return (
              <Tooltip placement="top" title={str}>
                <span>{str.substring(0, 12)}...</span>
              </Tooltip>
            );
          },
        },
        {
          title: '官网同步公众号',
          dataIndex: 'uploadWxTime',
          key: 'uploadWxTime',
          width: 150,
          render: (text, record) => {
            return (
              <Badge
                color={record.newsInfoExtend.uploadWxTime ? '#52C41A' : '#C3C3C3'}
                text={record.newsInfoExtend.uploadWxTime ? '已同步' : '未同步'}
              />
            );
          },
        },
        {
          title: '群发至公众号',
          dataIndex: 'pushWxTime',
          key: 'pushWxTime',
          fixed: 'right',
          width: 150,
          render: (text, record) => {
            return (
              <Badge
                color={record.newsInfoExtend.pushWxTime ? '#52C41A' : '#C3C3C3'}
                text={record.newsInfoExtend.pushWxTime ? '已群发' : '未群发'}
              />
            );
          },
        },
      ];
    }
    this.setState({ columns });
  };

  changePage = (page, pageSize) => {
    const { params, dispatch } = this.props;
    const tempParams = {
      ...params,
      page,
      pageSize,
    };
    dispatch({
      type: 'microToPublic/saveState',
      payload: {
        params: tempParams,
      },
    });
    this.fetchPublishList(tempParams);
  };

  select = (id, record) => {
    const { dispatch, selectedRow = [] } = this.props;
    const tempArr = [];
    const selectedRowKeys = [];
    let flag = true;

    selectedRow.forEach(item => {
      if (item.id === record.id) {
        flag = false;
      }
      tempArr.push(item);
      selectedRowKeys.push(item.id);
    });
    if (flag) {
      if (selectedRow.length === 8) {
        message.warning('最多只能选8篇');
        return;
      }
      tempArr.push(record);
      selectedRowKeys.push(record.id);
    } else {
      tempArr.splice(selectedRowKeys.indexOf(id), 1);
      selectedRowKeys.splice(selectedRowKeys.indexOf(id), 1);
    }

    dispatch({
      type: 'microToPublic/saveState',
      payload: {
        selectedRow: tempArr,
        selectedRowKeys,
      },
    });
  };

  // 全选
  selectAll = (selected, selectedRows) => {
    const { dispatch, selectedRow } = this.props;
    const { selectedRowKeys } = this.props;
    const arr = [];
    const idArr = [];
    selectedRow.forEach(item => {
      arr.push(item);
    });
    selectedRowKeys.forEach(item => {
      idArr.push(item);
    });
    if (selected) {
      dispatch({
        type: 'microToPublic/saveState',
        payload: {
          selectedRowAll: selectedRows,
        },
      });
      selectedRows.forEach(item => {
        if (selectedRowKeys.indexOf(item.id) === -1) {
          arr.push(item);
          idArr.push(item.id);
        }
      });
      if (arr.length > 8) {
        message.warning('最多只能选8篇');
      } else {
        // this.setState({
        //   selectedRowKeys: idArr
        // });
        dispatch({
          type: 'microToPublic/saveState',
          payload: {
            selectedRow: arr,
            selectedRowKeys: idArr,
          },
        });
      }
    } else {
      const { selectedRowAll } = this.props;
      const newArr = [];
      const newIdArr = [];
      const allIdArr = [];
      const allArr = [];

      selectedRowAll.forEach(item => {
        allIdArr.push(item.id);
        allArr.push(item);
      });
      selectedRowKeys.forEach(item => {
        if (allIdArr.indexOf(item) === -1) {
          newIdArr.push(item);
        }
      });
      selectedRow.forEach(item => {
        if (allIdArr.indexOf(item.id) === -1) {
          newArr.push(item);
        }
      });
      // this.setState({
      //   selectedRowKeys: newIdArr
      // });
      dispatch({
        type: 'microToPublic/saveState',
        payload: {
          selectedRow: newArr,
          selectedRowKeys: newIdArr,
        },
      });
    }
  };

  render() {
    const { columns, channelList = [] } = this.state;
    const { form, dataSource, params, totalElements, selectedRowKeys = [] } = this.props;
    const { page } = params;
    const { getFieldDecorator } = form;
    const formItemLayout = {
      labelCol: { span: 10 },
      wrapperCol: { span: 14 },
    };
    const rowSelection = {
      onChange: (selectedRowKeys, selectedRows) => {
        // selectedRows.map((item)=>{
        //   this.select(selectedRowKeys,item)
        // })
      },
      onSelect: (record, selected, selectedRows) => {
        this.select(record.id, record);
      },
      onSelectAll: (selected, selectedRows) => {
        //  selectedRows是当前全选选中的集合
        // selectedRow是之前已经选中的集合
        this.selectAll(selected, selectedRows);
      },
      selectedRowKeys,
    };

    // const pagination = {
    //   current: page,
    //   pageSize,
    //   total: totalElements,
    //   showQuickJumper: true,
    //   showSizeChanger: true,
    //   onChange: this.changePage,
    //   onShowSizeChange: this.changePage,
    // };

    const tableProps = {
      pageInfo: { totalElements, page },
      columns,
      list: dataSource,
      rowKey: 'id',
      rowSelection,
      onPageChange: this.changePage,
      onItemClick: this.select,
    };

    return (
      <div className={styles.root}>
        <Row className={styles['search-area']}>
          <Col span={8}>
            <Form.Item {...formItemLayout} label="栏目">
              {getFieldDecorator('channelId', {
                initialValue: [0],
              })(
                <Cascader
                  style={{ width: '100%' }}
                  options={channelList}
                  placeholder="请选择发布的栏目"
                />
              )}
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item {...formItemLayout} label="文章标题">
              {getFieldDecorator('title', {
                rules: [
                  {
                    max: 50,
                    message: '请勿超过50个字!',
                  },
                ],
              })(<Input placeholder="请输入标题" onPressEnter={this.search} />)}
            </Form.Item>
          </Col>
          <Col offset={16} className="search-button">
            <Form.Item>
              <Button type="primary" onClick={this.search}>
                查询
              </Button>
              <Button onClick={this.reSet}>重置</Button>
            </Form.Item>
          </Col>
        </Row>
        <section className="table-area">
          {/* <Table
            columns={columns}
            dataSource={dataSource}
            loading={loading}
            pagination={pagination}
            footer={() => `共 ${totalElements} 条记录 第 ${page} 页`}
            onRow={record => {
              return {
                onClick: () => {
                  this.select(record);
                },
              };
            }}
          /> */}
          <ListTable {...tableProps} />
        </section>
      </div>
    );
  }
}

const ArticleTableFrom = Form.create()(ArticleTable);
export default ArticleTableFrom;
